import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserFeedback } from 'src/app/models/UserFeedback.model';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { UserTicketStatus } from 'src/app/enums/userTicketStatus.enum';
import { UserFeedbackStatuses } from 'src/app/interfaces/userFeedback-Form';
@Component({
    selector: 'app-feedback-card',
    imports: [
        MatToolbarModule,
        MatTooltipModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatChipsModule,
        NgClass,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        MatCardModule,
        MatTableModule,
    ],
    templateUrl: './feedback-card.component.html',
    styleUrl: './feedback-card.component.scss',
})
export class FeedbackCardComponent {
    @Input() userView?: boolean;
    private _userFeedback: UserFeedback;
    protected readonly Status = UserTicketStatus;
    @Output() showTicketDetails = new EventEmitter<UserFeedback>();
    constructor(public dialog: MatDialog) {}

    @Input({ required: true })
    get userFeedback(): UserFeedback {
        return this._userFeedback;
    }

    set userFeedback(userFeedback: UserFeedback) {
        this._userFeedback = userFeedback;
    }

    protected seeDetails(): void {
        this.showTicketDetails.emit(this._userFeedback);
    }

    protected getStatus(): string {
        if (
            this.userFeedback.status === UserTicketStatus.Updated &&
            this._userFeedback.status !== UserTicketStatus.Processed &&
            this._userFeedback.status !== UserTicketStatus.Duplicate &&
            this._userFeedback.status !== UserTicketStatus.Read
        ) {
            return 'New Comments: ' + this._userFeedback.newComments;
        }

        return this.userFeedback.status;
    }
}
